function initUpsellForm() {
  //console.log("initUpsellForm initialized from cart-upsell.js");

  const forms = document.querySelectorAll(
    ".cart-upselling--form, .cart-upselling--form-slider"
  );
  if (!forms.length) return;

  forms.forEach((form) => {
    const variantIdInput = form.querySelector(".cart-upsell-variant-id");
    const qtyInput = form.querySelector(".cart-upsell-qty");
    const selects = form.querySelectorAll("select");

    let variants;
    try {
      variants = JSON.parse(form.dataset.variants || "[]");
    } catch (e) {
      console.error("Failed to parse variant data:", e);
      return;
    }

    if (!variants.length) {
      console.warn("No variants found for upsell form.");
      return;
    }

    function getSelectedVariant() {
      const selectedOptions = Array.from(selects).map((select) => select.value);
      return variants.find((variant) =>
        variant.options.every((opt, index) => opt === selectedOptions[index])
      );
    }

    function updateVariantData() {
      const selectedVariant = getSelectedVariant();
      if (!selectedVariant) return;

      variantIdInput.value = selectedVariant.id;

      const rule = selectedVariant.quantity_rule || {};
      qtyInput.min = rule.min || 1;
      qtyInput.step = rule.increment || 1;
      qtyInput.value = rule.min || 1;

      if (rule.max != null) {
        qtyInput.max = rule.max;
      } else {
        qtyInput.removeAttribute("max");
      }
    }

    updateVariantData();
    selects.forEach((select) =>
      select.addEventListener("change", updateVariantData)
    );

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      const submitButton = form.querySelector('button[type="submit"]');
      submitButton.disabled = true;
      submitButton.classList.add("loading");

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      })
        .then((res) => {
          if (!res.ok) throw new Error("Add to cart failed");
          return res.json();
        })

        .then(() => {
          // Fetch updated cart bubble section
          return fetch(`/cart?section_id=cart-icon-bubble`);
        })
        .then((res) => res.text())
        .then((html) => {
          // Extract the cart bubble HTML from the response
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const updatedBubble = doc.querySelector(".shopify-section");

          if (updatedBubble) {
            const target = document.querySelector(
              "#cart-icon-bubble .shopify-section"
            );
            if (target) {
              target.innerHTML = updatedBubble.innerHTML;
            } else {
              // Fallback if your theme structure is slightly different
              document.getElementById("cart-icon-bubble").innerHTML =
                updatedBubble.innerHTML;
            }
          }
        })
        .then(() => reInitCartDrawer())
        .catch((err) => console.error("Error:", err))
        .finally(() => {
          submitButton.disabled = false;
          submitButton.classList.remove("loading");
        });
    });
  });
}

function reInitCartDrawer() {
  fetch("/?section_id=cart-drawer")
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newDrawer = doc.querySelector("#CartDrawer");
      const currentDrawer = document.querySelector("#CartDrawer");

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;

        setTimeout(() => {
          initUpsellForm();

          // ✅ Only re-init Swiper if function exists
          if (typeof initSwiperCartUpsellBlock === "function") {
            initSwiperCartUpsellBlock();
          }
          //bindCartDeleteButtons(); // 💡 <- Hook delete rebinding here
          //console.log("Cart reloaded and upsell re-initialized");
        }, 50);
      }
    });
}

subscribe(PUB_SUB_EVENTS.cartUpdate, ({ source }) => {
  //console.log("[PUBSUB] cartUpdate triggered by:", source);
  initUpsellForm();

  // ✅ Only re-init Swiper if function exists
  if (typeof initSwiperCartUpsellBlock === "function") {
    initSwiperCartUpsellBlock();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  initUpsellForm();
});

function addToCart(variantId, quantity = 1) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: variantId, quantity }),
  })
    .then(() => {
      // Fetch updated cart bubble section
      return fetch(`/cart?section_id=cart-icon-bubble`);
    })
    .then((res) => res.text())
    .then((html) => {
      // Extract the cart bubble HTML from the response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const updatedBubble = doc.querySelector(".shopify-section");

      if (updatedBubble) {
        const target = document.querySelector(
          "#cart-icon-bubble .shopify-section"
        );
        if (target) {
          target.innerHTML = updatedBubble.innerHTML;
        } else {
          // Fallback if your theme structure is slightly different
          document.getElementById("cart-icon-bubble").innerHTML =
            updatedBubble.innerHTML;
        }
      }
    })
    .catch((err) => console.error("Cart update error:", err));
}

//add product b if product a is added to cart
function autoAddProductToCart() {
  const configEl = document.querySelector("#auto-add-product");
  if (!configEl) return;

  const triggerProductId = configEl.dataset.triggerId;
  const productToAddId = configEl.dataset.productToAdd;
  const propertyKey = configEl.dataset.cartPropertyKey;
  const propertyValue = configEl.dataset.cartPropertyValue;
  const deleteAuto = configEl.dataset.deleteAuto;


  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const hasTrigger = cart.items.some(
        (item) => item.product_id == triggerProductId
      );
      const bonusItem = cart.items.find(
        (item) =>
          item.variant_id == productToAddId &&
          item.properties?.[propertyKey] == propertyValue
      );

      // If Product A is in the cart and Product B is NOT, add Product B
      if (hasTrigger && !bonusItem) {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: productToAddId,
            quantity: 1,
            properties: {
              [propertyKey]: propertyValue,
            },
          }),
        })
          .then((res) => res.json())
          .then(() => {
            // Fetch updated cart bubble section
            return fetch(`/cart?section_id=cart-icon-bubble`);
          })
          .then((res) => res.text())
          .then((html) => {
            // Extract the cart bubble HTML from the response
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const updatedBubble = doc.querySelector(".shopify-section");

            if (updatedBubble) {
              const target = document.querySelector(
                "#cart-icon-bubble .shopify-section"
              );
              if (target) {
                target.innerHTML = updatedBubble.innerHTML;
              } else {
                // Fallback if your theme structure is slightly different
                document.getElementById("cart-icon-bubble").innerHTML =
                  updatedBubble.innerHTML;
              }
            }
          })
          .then((data) => {
            //console.log("🛒 Bonus product added:", data);
            if (typeof reInitCartDrawer === "function") reInitCartDrawer();
          });
      }

      
        
      // If Product A is NOT in the cart but Product B IS, remove Product B
      if (!hasTrigger && bonusItem) {

        // If Product A is NOT in the cart but Product B IS, remove Product B only if deleteAuto is enabled
      //console.log("DeleteAuto Value"+deleteAuto);
      if( deleteAuto == 'true' ) {
        
        return fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: bonusItem.key,
            quantity: 0,
          }),
        })
          .then((res) => res.json())

          .then(() => {
            // Fetch updated cart bubble section
            return fetch(`/cart?section_id=cart-icon-bubble`);
          })
          .then((res) => res.text())
          .then((html) => {
            // Extract the cart bubble HTML from the response
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const updatedBubble = doc.querySelector(".shopify-section");

            if (updatedBubble) {
              const target = document.querySelector(
                "#cart-icon-bubble .shopify-section"
              );
              if (target) {
                target.innerHTML = updatedBubble.innerHTML;
              } else {
                // Fallback if your theme structure is slightly different
                document.getElementById("cart-icon-bubble").innerHTML =
                  updatedBubble.innerHTML;
              }
            }
          })
          .then(() => {
            //console.log("🗑️ Bonus product removed");
            if (typeof reInitCartDrawer === "function") reInitCartDrawer();
          });
        }

      }

      
    })
    .catch((err) => console.error("❌ Error in autoAddProductToCart:", err));
}

// Run it on page load or after cart update
document.addEventListener("DOMContentLoaded", autoAddProductToCart);

// Optional: hook into AJAX cart updates
document.addEventListener("cart:updated", autoAddProductToCart); // if you have a custom event

subscribe(PUB_SUB_EVENTS.cartUpdate, ({ source }) => {
  //console.log("[PUBSUB] cartUpdate triggered by:", source);
  autoAddProductToCart();
});


